var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7179 4.39687L10.808 1.80512L10.1929 3.444L12.6735 4.375H3.5C2.534 4.375 1.75 5.159 1.75 6.125V16.625C1.75 17.591 2.534 18.375 3.5 18.375H17.5C18.466 18.375 19.25 17.591 19.25 16.625V6.125C19.25 5.2325 18.5797 4.50537 17.7179 4.39687ZM8.75 14.875H5.25V13.125H8.75V14.875ZM14.4375 15.75C13.2291 15.75 12.25 14.7709 12.25 13.5625C12.25 12.3541 13.2291 11.375 14.4375 11.375C15.6459 11.375 16.625 12.3541 16.625 13.5625C16.625 14.7709 15.6459 15.75 14.4375 15.75ZM17.5 9.625H3.5V6.125H17.5V9.625Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.125H8.75V14.875H5.25V13.125Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 15.75C15.6456 15.75 16.625 14.7706 16.625 13.5625C16.625 12.3544 15.6456 11.375 14.4375 11.375C13.2294 11.375 12.25 12.3544 12.25 13.5625C12.25 14.7706 13.2294 15.75 14.4375 15.75Z",
    fill: "#8E34F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 12.25V13.125",
    stroke: "#404040",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.cea443cd128eea004527edefebe78fb2.svg";
export { ForwardRef as ReactComponent };